import { AsyncTypeahedSelect, RichTextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, getFormSyncErrors, isDirty, reset } from "redux-form"
import { getUsersBySearch } from "store/actions"

const ConfirmationMessageTab = ({
  getUsersBySearch,
  usersBySearch,
  isDirty,
  resetForm,
  tabIsActive,
  handleSave,
  formSyncErrors,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (
      !tabIsActive &&
      isDirty &&
      (!formSyncErrors || Object?.keys(formSyncErrors)?.length === 0)
    ) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>CONFIRMATION MESSAGE</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <label>
                Select users which will be notified when an order is placed:
              </label>
            </Col>
          </Row>
          <Row>
            <Col xs="auto">
              <div style={{ minWidth: "350px" }}>
                <Field
                  name="selectedAdmins"
                  component={AsyncTypeahedSelect}
                  placeholder="Search for specific users"
                  inlineValue={false}
                  isMulti={true}
                  options={usersBySearch.map(user => ({
                    label: `${user?.first_name} ${user?.last_name} (${user?.email})`,
                    value: user.id,
                  }))}
                  onInputChange={text =>
                    getUsersBySearch({
                      include_admins: true,
                      t: text,
                      include_pending: true
                    })
                  }
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>Compose confirmation message for after purchase:</label>
            </Col>
          </Row>
          <Row>
            <Col>
              <Field name="confirmationMessage" component={RichTextField} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.PRODUCT)(state, ...["confirmationMessage"]),
  formSyncErrors: getFormSyncErrors(FORM_NAMES.PRODUCT)(state),
  usersBySearch: state.SiteUsers.usersBySearch,
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.PRODUCT)),
  getUsersBySearch: values => dispatch(getUsersBySearch(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmationMessageTab)
